exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home{display:flex;justify-content:center;align-items:center;height:400px;position:relative}#home #app-front-cover-inner{text-align:center;padding-left:200px}#home #app-front-cover-inner h1{color:#242424;font-size:5em;margin:10px 0;min-width:350px}#home #app-front-cover-inner p{color:#606060;font-size:1.2em;margin:0}#home #app-front-cover-image{height:800px;margin-top:140px;z-index:-1;opacity:.8;filter:drop-shadow(0 4px 32px rgba(0,0,0,.1))}@media (max-width:1080px){#home #app-front-cover-inner{background-color:hsla(0,0%,100%,.8);border-radius:8px;padding:40px}#home #app-front-cover-image{position:absolute}}@media (max-width:640px){#home{height:300px}#home #app-front-cover-inner h1{font-size:4em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7494450a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Home/Cover.vue
// module id = 37
// module chunks = 0